module.exports = __webpack_public_path__ + "media/images/www/guide/good_bad/good/pull_items-f636351ade53d47d3bff8872022fce63.png";